import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=8c6c32a8&scoped=true&"
var script = {}
import style0 from "./Testimonial.vue?vue&type=style&index=0&id=8c6c32a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6c32a8",
  null
  
)

export default component.exports